module.exports = __webpack_public_path__ + "static/media/invalid.0140f6fd.svg";